import React from 'react';
import { IExtendedMessage } from 'interfaces/message-interfaces';

export function NewSubscriberTag({ message }: { message: IExtendedMessage }) {
  return <div>New Subscriber entered</div>;
}
